import { mobileTest } from "../components/utils/helpers.js";

// MOBILE DETECT
export function isMobile() {
	return {
		type: "IS_MOBILE",
		mobile: mobileTest()
	};
}
export function addScore(item, value) {
	return {
		type: "SCORE_INCREASE",
		item,
		value
	};
}

export function initializeUser() {
	return {
		type: "INITIALIZE_USER"
		// meta: { sound: 'startGame' }
	};
}

// get token/id for Rage Click replay (via FullStory)
export function setEmbedToken() {
	return dispatch => {
		setTimeout(() => {
			window._fs_shutdown("embedToken");
			const token = document
				.getElementById("embedToken")
				.getAttribute("_fs_embed_token");
			console.log(token);
			dispatch({ type: "SET_EMBED_TOKEN", token });
		}, 2000);
	};
}

export function deletePlaybackToken() {
	console.log("deletePlaybackTokenAction");
	return {
		type: "DELETE_PLAYBACK_TOKEN"
	};
}

export function itemsHasErrored(bool) {
	return {
		type: "ITEMS_HAS_ERRORED",
		hasErrored: bool
	};
}

export function itemsIsLoading(bool) {
	return {
		type: "ITEMS_IS_LOADING",
		isLoading: bool
	};
}

export function itemsFetchDataSuccess(items) {
	return {
		type: "ITEMS_FETCH_DATA_SUCCESS",
		items
	};
}

// thunks!
export function getHighScores() {
	// console.log('getHighScores');
	return dispatch => {
		dispatch(itemsIsLoading(true));

		fetch("https://us-central1-rage-click.cloudfunctions.net/getAllScores", {
			cache: "no-cache",
			method: "GET",
			mode: "cors"
		})
			.then(response => {
				if (!response.ok) {
					throw Error(response.statusText);
				}
				dispatch(itemsIsLoading(false));
				return response;
			})
			.then(response => response.json())
			.then(highScores => {
				dispatch(setHighScores(highScores));
			})
			.catch(() => dispatch(itemsHasErrored(true)));
	};
}

export function setHighScores(highScores) {
	return {
		type: "SET_HIGH_SCORES",
		highScores: highScores
	};
}

export function getRank(score) {
	// console.log("getRank");
	return dispatch => {
		dispatch(itemsIsLoading(true));
		fetch(
			`https://us-central1-rage-click.cloudfunctions.net/getRank?score=${score}`,
			{
				cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
				method: "GET",
				mode: "cors"
			}
		)
			.then(response => {
				if (!response.ok) {
					throw Error(response.statusText);
				}
				dispatch(itemsIsLoading(false));
				return response;
			})
			.then(response => response.json())
			.then(rank => {
				console.log("dispatch rank!", rank);
				dispatch(setRank(rank));
			})
			.catch(() => dispatch(itemsHasErrored(true)));
	};
}

export function setRank(rank) {
	return {
		type: "SET_RANK",
		rank: rank
	};
}

export function postScore(score, twitterAccount) {
	// console.log("post store");
	return dispatch => {
		dispatch(itemsIsLoading(true));

		fetch(
			`https://us-central1-rage-click.cloudfunctions.net/addScore?score=${score}&twitterHandle=${twitterAccount}`,
			{
				cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
				method: "GET",
				mode: "cors"
			}
		)
			.then(response => {
				if (!response.ok) {
					throw Error(response.statusText);
				}

				dispatch(itemsIsLoading(false));

				return response;
			})
			.then(response => response.json())
			.then(scoreSubmitted => {
				// console.log("score submitted!", scoreSubmitted);
			})
			.catch(() => dispatch(itemsHasErrored(true)));
	};
}

// audio
export function startVoice() {
	return {
		type: "START_VOICE"
	};
}
export function volumeDown() {
	return {
		type: "VOLUME_DOWN",
		meta: { sound: "volume" }
	};
}
//  audio only
export function gameMusic( track ) {
	return {
		type: "snd",
		meta: {
			sound: track,
			channel: "music",
			op: "play"
		}
	};
}
export function siteDownMusic() {
	return {
		type: "snd",
		meta: { sound: "eas", channel: "music", op: "play" }
	};
}
export function siteDownMusicStop() {
	return {
		type: "snd",
		meta: { sound: "eas", channel: "music", op: "stop" }
	};
}
export function dialogMusic() {
	return {
		type: "snd",
		meta: { sound: "dialogMusic", channel: "music", op: "play" }
	};
}
export function pattern2dIn() {
	return {
		type: "snd",
		meta: { sound: "twoDDarkPatternAppear", channel: "fx", op: "playFx" }
	};
}
export function pattern2dOut() {
	return {
		type: "snd",
		meta: { sound: "twoDRageIncrease", channel: "fx", op: "playFx" }
	};
}

export function twoDDarkPatternCorrect() {
	return {
		type: "snd",
		meta: { sound: "twoDDarkPatternCorrect", channel: "fx", op: "playFx" }
	};
}
export function twoDDarkPatternIncorrect() {
	return {
		type: "snd",
		meta: { sound: "twoDDarkPatternIncorrect", channel: "fx", op: "playFx" }
	};
}

export function playSndFx(sound) {
	return {
		type: "snd",
		meta: { sound: sound, channel: "fx", op: "playFx" }
	};
}

export function voiceStatic(voice) {
	return {
		type: "snd",
		meta: { sound: voice, channel: "voice", op: "play" }
	};
}

export function fadeMusic() {
	return {
		type: "snd",
		meta: { sound: "", channel: "music", op: "fade" }
	};
}

export function fadeVoice() {
	return {
		type: "snd",
		meta: { sound: "", channel: "voice", op: "fade" }
	};
}

export function stopVoice() {
	return {
		type: "snd",
		meta: { sound: "", channel: "voice", op: "stopVoice" }
	};
}

export function setMute(mute) {
	return { 
		type: "SET_MUTE",
		mute: mute
	}
}
export function toggleMute() {
	return { type: "TOGGLE_MUTE", meta: { sound: "", op: "mute" } };
}

export function audioChosen() {
	return { type: "AUDIO_CHOSEN" };
}



// WEBPACK FOOTER //
// ./src/actions/actionCreators.js